export const ROUTE_SOURCE_ID = "start-point-route-source";
export const ROUTE_LAYER_ID = "start-point-route-layer";
export const COMBINED_ROUTE_SOURCE_ID = "all-tour-routes-preview-source";
export const COMBINED_ROUTE_DRIVING_LAYER_ID = "all-tour-routes-driving-layer";
export const COMBINED_ROUTE_WALKING_LAYER_ID = "all-tour-routes-walking-layer";
export const COMBINED_ROUTE_RANDOM_LAYER_ID = "all-tour-routes-random-layer";
export const BOUNDARY_SOURCE_ID = "map-boundary-source";
export const BOUNDARY_FILL_LAYER_ID = "map-boundary-fill-layer";
export const BOUNDARY_LINE_LAYER_ID = "map-boundary-line-layer";
export const ROUTE_SHAPE_POINT_SOURCE_ID = "route-shape-point-source";
export const ROUTE_SHAPE_POINT_LAYER_ID = "route-shape-point-layer";
export const ROUTE_SHAPE_DELETE_BG_LAYER_ID = "route-shape-delete-bg-layer";
export const ROUTE_SHAPE_DELETE_TEXT_LAYER_ID = "route-shape-delete-text-layer";
export const ROUTE_SHAPE_CLICK_TOLERANCE_PX = 14;
export const MEASUREMENT_SOURCE_ID = "map-distance-measurement-source";
export const MEASUREMENT_LINE_LAYER_ID = "map-distance-measurement-line";
export const MEASUREMENT_POINT_LAYER_ID = "map-distance-measurement-points";
export const MEASUREMENT_LABEL_LAYER_ID = "map-distance-measurement-label";
